<template>
  <div class="option-list-wrapper">
    <ul class="option-list pl-0 mb-0">
      <li v-for="(item, index) in options"
        :key="index"
        class="option-list__item pointer"
        :class="{ 'option-list__item--active': item.value === value }"
        @click="$emit('input', item.value); $emit('change', item.value);"
        >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OptionList',
  props: {
    options: {
      type: Array,
      required: true,
      validator(array) {
        return array.every(item => item.name);
      },
    },
    value: null,
  },
};
</script>

<style lang="scss" scoped>
.option-list__item {
  list-style: none;
  color: #B1B1B1;
  padding-left: 20px;
  @include text-size-regular();
}

.option-list__item--active {
  background: url('~@/assets/images/icon_check.svg') left center no-repeat;
  color: #000;
}
</style>
